// ======================================================================
// File Name       : PageHeaderContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ModalCondutor } from '../components/modal/ModalConductorConstants';
import TopNav from '../components/TopNav';
import TopNavigator from '../components/TopNavigator';
import {
  INQUIRY_SUPPORT_URL,
  FAQ_URL,
  SUPER_USER,
  ROOT_URL,
  NEW_SERVICE_MANAGEMENT_URL,
  ENTERPRISE_SWITCHING_MANAGEMENT_URL,
  INTEGRATION_USER_MANAGEMENT_URL,
} from "../constants";
import { SUPERUSER_LOGIN_TYPE } from '../constants/CommonConstants';
import { isIntegrationUserLoggedIn } from '../utils/PageUtils';

class PageHeader extends Component {
  constructor() {
    super();
    this.state = {
      showSubMenu: false,
    };
    this.collapseSubMenu = this.collapseSubMenu.bind(this);
    this.openInquiry = this.openInquiry.bind(this);
    this.openFaqPage = this.openFaqPage.bind(this);
    this.redirectToServicePage = this.redirectToServicePage.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  // Step 11.0.0 START
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  static getDerivedStateFromProps(nextProps, state) {
    const isShowModal = !!nextProps.modalId && {}.hasOwnProperty.call(ModalCondutor, nextProps.modalId);
    if (isShowModal) {
      return {
        ...state,
        showSubMenu: false,
      };
    }
    return state;
  }
  // Step 11.0.0 END

  // Step 11.0.0 START
  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (match.url !== prevProps.match.url) {
      this.setState({
        showSubMenu: false,
      });
    }
  }

  handleClickOutside = (event) => {
    const divEl = document.getElementById('top-navigator-dropdown-menu');
    if (divEl && event.target.id !== 'topMenuBtn' && !divEl.contains(event.target)) {
      this.setState({
        showSubMenu: false,
      });
    }
  }
  // Step 11.0.0 END

  collapseSubMenu() {
    const { showSubMenu } = this.state;
    this.setState({
      showSubMenu: !showSubMenu,
    });
  }

  openInquiry() {
    const newPage = window.open(`${INQUIRY_SUPPORT_URL}`, '_blank');
    newPage.focus();
  }

  openFaqPage() {
    const newPage = window.open(`${FAQ_URL}`, '_blank');
    newPage.focus();
  }

  redirectToServicePage() {
    const { isEnterpriseHasOneService, superuserType } = this.props;
    let targetUrl = isEnterpriseHasOneService ? `${ROOT_URL}/top` : NEW_SERVICE_MANAGEMENT_URL;
    if (superuserType === SUPERUSER_LOGIN_TYPE.INTEGRATION_ROOT_SUPERUSER) {
      targetUrl = INTEGRATION_USER_MANAGEMENT_URL;
    } else if (
      superuserType === SUPERUSER_LOGIN_TYPE.INTEGRATION_SUPERUSER
      && isIntegrationUserLoggedIn
    ) {
      targetUrl = ENTERPRISE_SWITCHING_MANAGEMENT_URL;
    }
    window.location.href = targetUrl;
  }

  render() {
    const {
      panelData,
      topNavigatorDatas,
      match,
      logout,
      contractEnterpriseHiddenStatus,
      isSuperUserL0,
      displayUserType,
      isEnterpriseLayerL1,
      isShowContract,
      isTrialExpire,
      hiddenStatusSetting,
      integrationUser,
      authedUser,
    } = this.props;
    const { url } = match;
    const isSuperUserL1 = [SUPER_USER].indexOf(displayUserType) > -1 && isEnterpriseLayerL1;
    // Step 11.0.0 START
    let hiddenStatus;
    if ((isSuperUserL0 || isSuperUserL1)) {
      hiddenStatus = hiddenStatusSetting > contractEnterpriseHiddenStatus ? hiddenStatusSetting : contractEnterpriseHiddenStatus;
    } else {
      hiddenStatus = contractEnterpriseHiddenStatus;
    }
    // Step 11.0.0 END
    // STEP 12.0.0 START
    if (integrationUser && Object.keys(integrationUser).length) {
      panelData.userName = integrationUser.superuserName;
      panelData.enterpriseCd = integrationUser.enterpriseCd;
      panelData.enterpriseName = integrationUser.enterpriseName;
      panelData.lastLoginTime = integrationUser.lastLoginTime;
    }
    // STEP 12.0.0 END

    return (
      <div className="top-navigator">
        <TopNavigator
          panelData={panelData}
          collapseSubMenu={this.collapseSubMenu}
          showSubMenu={this.state.showSubMenu}
          topNavigatorDatas={topNavigatorDatas}
          url={url}
          logout={logout}
          hiddenStatus={hiddenStatus}
          isShowContract={isShowContract}
          isTrialExpire={isTrialExpire}
          openInquiry={this.openInquiry}
          openFaqPage={this.openFaqPage}
          redirectToServicePage={this.redirectToServicePage}
          authedUser={authedUser}
        />
      </div>
    );
  }
}

PageHeader.prototypes = {
  panelData: PropTypes.shape({
    serviceName: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
  }).isRequired,
  topNavigatorDatas: PropTypes.array.isRequired,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { authedUser, topNavigatorDatas } = state.authed;
  const {
    enterpriseName,
    serviceName,
    userInfo,
    enterpriseCd,
    serviceCd,
    isOEMUser,
    contractEnterpriseHiddenStatus,
    isEnterpriseLayerL1,
    enterpriseManagementFunctionAuthorityInfo,
  } = authedUser;
  const { showHintModal, modalId } = state.modal;
  const { recordNum } = state.serviceRecord.serviceInfo;
  const { integrationUser } = state.user;
  const isEnterpriseHasOneService = recordNum === 1;
  // Step 11.0.0 START
  const hiddenStatusSetting = enterpriseManagementFunctionAuthorityInfo && enterpriseManagementFunctionAuthorityInfo.hiddenStatusSetting;
  // Step 11.0.0 END
  return {
    panelData: {
      enterpriseName,
      serviceName,
      userName: userInfo.userName,
      enterpriseCd,
      serviceCd,
      lastLoginTime: userInfo.lastLoginTime,
      isOEMUser,
    },
    topNavigatorDatas,
    showHintModal,
    contractEnterpriseHiddenStatus,
    displayUserType: userInfo.displayUserType,
    isEnterpriseLayerL1,
    isEnterpriseHasOneService,
    hiddenStatusSetting,
    modalId,
    superuserType: userInfo.superuserType,
    integrationUser,
    authedUser,
  };
};
export default connect(mapStateToProps)(PageHeader);
